import React, { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import PageContainer from "./layout/PageContainer.js";
import JsonLd from "./JsonLd.js";
import GuideCoverHero from "./guide/GuideCoverHero.js";
import GuideTableOfContents from "./guide/GuideTableOfContents.js";
import { MENTAL_CLARITY_GUIDE } from "../constants/mentalClarityGuide.js";
import { GUIDE_COVER } from "../constants/mentalClarityGuideVisuals.js";
import { buildGuideJsonLd } from "../utils/guideJsonLd.js";
import "../mental-clarity-guide.css";

const DEFAULT_TITLE = "Ahavibes — Stop reacting. Start thinking clearly.";
const DEFAULT_DESCRIPTION =
  "A guided framework to examine interpretations, reduce mental noise, and make better decisions.";
const PAGE_TITLE = "The Complete Guide to Mental Clarity | Ahavibes";

const MentalClarity = () => {
  const jsonLd = useMemo(() => buildGuideJsonLd(MENTAL_CLARITY_GUIDE), []);

  useEffect(() => {
    document.title = PAGE_TITLE;

    let meta = document.querySelector('meta[name="description"]');
    const createdMeta = !meta;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    const previousDescription = meta.getAttribute("content");
    meta.setAttribute("content", MENTAL_CLARITY_GUIDE.description);

    return () => {
      document.title = DEFAULT_TITLE;
      if (createdMeta) {
        meta.remove();
      } else {
        meta.setAttribute("content", previousDescription || DEFAULT_DESCRIPTION);
      }
    };
  }, []);

  return (
    <>
      <JsonLd data={jsonLd} id="mental-clarity-jsonld" />
      <PageContainer size="wide" className="mental-clarity-guide">
        <GuideCoverHero
          headline={MENTAL_CLARITY_GUIDE.headline}
          lead={MENTAL_CLARITY_GUIDE.description}
          cover={GUIDE_COVER}
        />
        <GuideTableOfContents sections={MENTAL_CLARITY_GUIDE.sections} basePath="/mental-clarity" />
        <nav className="guide-section-nav" aria-label="Pillar navigation">
          <div className="guide-section-nav__links">
            <Link to="/guide" className="guide-section-nav__link guide-section-nav__link--prev">
              &larr; All Guides
            </Link>
            <Link to="/mental-noise" className="guide-section-nav__link guide-section-nav__link--next">
              Next: Mental Noise &rarr;
            </Link>
          </div>
        </nav>
      </PageContainer>
    </>
  );
};

export default MentalClarity;
